function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.0433 18.0443C22.9807 13.1069 31.0193 13.1069 35.9567 18.0443C40.8941 22.9817 40.8941 31.0203 35.9567 35.9577C31.0193 40.895 22.9807 40.895 18.0433 35.9577C13.1059 31.0203 13.1059 22.9817 18.0433 18.0443ZM15.8041 15.8051C9.62066 21.9886 9.62066 32.0134 15.8041 38.1968C21.9876 44.3803 32.0124 44.3803 38.1959 38.1968C44.3793 32.0134 44.3793 21.9886 38.1959 15.8051C32.0124 9.62165 21.9876 9.62165 15.8041 15.8051ZM31.4783 20.2835L27 24.7618L22.5216 20.2835L20.2825 22.5226L24.7608 27.001L20.2825 31.4793L22.5216 33.7185L27 29.2401L31.4783 33.7185L33.7175 31.4793L29.2392 27.001L33.7175 22.5226L31.4783 20.2835Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.129883,
  y: 27.001,
  width: 38,
  height: 38,
  transform: "rotate(-45 0.129883 27.001)"
})));

var SvgClosex = function SvgClosex(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClosex, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closex.344a15ae.svg";
export { ForwardRef as ReactComponent };